import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const InfoOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M12 3.79c4.53 0 8.21 3.68 8.21 8.21 0 4.53-3.68 8.21-8.21 8.21-4.53 0-8.21-3.68-8.21-8.21 0-4.53 3.68-8.21 8.21-8.21Zm0-1.56C6.6 2.23 2.23 6.6 2.23 12c0 5.4 4.38 9.77 9.77 9.77s9.77-4.38 9.77-9.77S17.4 2.23 12 2.23Z" />
      <Path d="M12.5 10.53c.14.13.22.32.26.56l.73 4.34c0 .06.01.13.01.22 0 .42-.14.75-.43.98-.29.23-.64.36-1.07.36-.43 0-.8-.12-1.08-.36s-.42-.57-.42-.99c0-.09 0-.17.01-.22l.74-4.33c.03-.24.11-.43.24-.56.13-.13.3-.2.5-.2s.36.06.5.2h.01Zm.47-3.14c.26.26.38.58.38.96s-.13.7-.38.96c-.26.26-.58.39-.97.39s-.7-.13-.96-.39-.38-.58-.38-.96.13-.7.38-.96c.26-.26.57-.39.96-.39s.71.13.97.39Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default InfoOutlined
